<script>
export default {
  name: 'TreeBase',
  props: {
    treeItem: {
      type: Object,
      default: undefined,
    },

    treeDepth: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      isTreeComponent: true,
      expanded: true,
    }
  },

  computed: {
    children() {
      return this.hasChildren ? this.treeItem.children : []
    },

    /**
     * 트리 노드가 자식 노드를 가지고있는 내부 노드입니다.
     * @returns {*}
     */
    isInternalNode() {
      return this.hasChildren
    },

    /**
     * 트리 노드가 자식 노드를 가지고있지 않은 잎 노드입니다.
     * @returns {boolean}
     */
    isLeafNode() {
      return !this.hasChildren
    },

    /**
     * 트리 노드에 자식 요소가 있는지 여부를 반환합니다.
     * @returns {boolean}
     */
    hasChildren() {
      return !(
        !this.treeItem ||
        !this.treeItem.children ||
        this.treeItem.children.length <= 0
      )
    },

    depthNext() {
      return this.treeDepth + 1
    },
  },

  watch: {
    expanded(newValue, oldValue) {
      if (newValue) {
        this.$emit('expanded', newValue)
      } else {
        this.$emit('collapsed', newValue)
      }
      this.$emit('toggle', newValue)
    },
  },

  methods: {
    collapse() {
      if (this.hasChildren) {
        this.expanded = false
      }
      this.propagate(false)
    },

    expand() {
      if (this.hasChildren) {
        this.expanded = true
      }
      this.propagate(true)
    },

    propagate(expanded) {
      this.$children.forEach((child) => {
        // 자식이 존재하지 않거나 트리 컴포넌트가 아니라면 아무것도 하지 않습니다.
        if (!child || !child.isTreeComponent) return
        expanded ? child.expand() : child.collapse()
      })
    },

    toggle() {
      // 자식 요소가 없으면 토글할 필요가 없습니다.
      if (!this.hasChildren) return
      //  확장 상태를 반전합니다.
      this.expanded = !this.expanded
    },
  },
}
</script>
